import { deleteBeneficiary } from '@/libs/api/beneficiary/delete'
import { getList } from './list'
import { getCurrencyList } from './currency-list'
import { getIbanInfo } from './iban-info'
import { addBeneficiary } from './add'
import { getBeneficiary } from './get'
import { updateBeneficiary } from '@/libs/api/beneficiary/update.js'
import { updateSortOrder } from '@/libs/api/beneficiary/sort-order.js'

export default {
  getList,
  getCurrencyList,
  getIbanInfo,

  addBeneficiary,
  getBeneficiary,
  updateBeneficiary,
  updateSortOrder,
  deleteBeneficiary,
}
